import PropTypes from 'prop-types';

const FunctionalCell = (props) => {
  const { contact, value } = props;

  return value(contact, props);
};

FunctionalCell.propTypes = {
  contact: PropTypes.shape({
    id: PropTypes.string
  }),
  value: PropTypes.func
};

FunctionalCell.defaultProps = {
  contact: {},
  value: () => false
};

export default FunctionalCell;
